import styled from 'styled-components';

const VehicleStateImg = styled.img.attrs({
  className: 'vehicle-state-img',
})`
  cursor: pointer;

  :hover {
    opacity: 0.75;
  }
`;

export default VehicleStateImg;
